import { Weapon } from '../../Weapon.js';
import { FUSED_WEAPONS } from '../../../../../config/constants.js';

/**
 * Shatterpoint (Harmonics fusion: Resonor + Nova Pulse) — Nova Pulse's
 * centered AoE with the Resonor's habit of saving up and spending at once.
 *
 * A single heavy blast on a long `fireRate` rather than a continuous hum: the
 * gap is the point, because a detonation you can feel coming is one you can
 * position for. At max fusion level each blast is answered by a smaller
 * aftershock halfway to the next one, which fills the gap without closing it.
 */
export class Shatterpoint extends Weapon {
  constructor() {
    super(FUSED_WEAPONS.shatterpoint);
    this._echo = null; // { timer } — the max-level aftershock
  }

  _radius() {
    return this.config.radius + this.level * 4;
  }

  _damage() {
    return this.config.pulseDamage + this.level * this.config.pulseDamagePerLevel;
  }

  update(dt, origin, _target, pool) {
    this.fireFlash = Math.max(0, this.fireFlash - dt);

    if (this._echo) {
      this._echo.timer -= dt;
      if (this._echo.timer <= 0) {
        this._echo = null;
        this._burst(origin, pool, this.config.echoRadiusScale, this.config.echoDamageScale);
      }
    }

    this.timer -= dt;
    if (this.timer > 0) return;
    this.timer = this.config.fireRate;
    this._pulse(origin, pool, this.config.fireRate);
  }

  // `period` is however long it'll be until the next blast — the max-level
  // aftershock splits that gap in half.
  _pulse(origin, pool, period) {
    this._burst(origin, pool, 1, 1);
    this.lastBurstRadius = this._radius();
    this.fireFlash = 0.12;
    if (this.level >= this.config.maxLevel) this._echo = { timer: period / 2 };
  }

  _burst(origin, pool, radiusScale, damageScale) {
    pool.fire({
      x: origin.x,
      y: origin.y,
      radius: this._radius() * radiusScale,
      damage: this._damage() * damageScale,
      hits: 1,
      lifetime: 0.2,
      color: this.config.color,
      style: 'ring',
    });
  }
}
